import Layout from "./Layout";

const News = () => {
    return (
        <Layout>

            <h1 className="text-center text-3xl text-[#0a1a42] mt-12">News and Announcement</h1>

            <div className="ml-8 md:ml-12 mt-4">

                <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                    <a href="/">
                        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Noteworthy technology acquisitions 2021</h5>
                    </a>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                        This is the News and Announcement Area both for
                        students, parents, partners, job seekers, and our
                        Alumni Community. Stay updated with happenings and
                        activities inside DRIC.
                    </p>
                    <div>
                        <span className="flex text-sm space-x-4 text-gray-700">
                            <h6> By
                                eskoolnow</h6>
                            <h6>November 10, 2022</h6>
                        </span>
                    </div>
                    <a href="/" className="inline-flex mt-4 items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#f7951e] rounded-lg bg-[#f7951e] focus:ring-4 focus:outline-none ">
                        Read more
                        <svg className="w-3.5 h-3.5 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                        </svg>
                    </a>
                </div>

            </div>



        </Layout>
    );
}

export default News;